export const DEFAULT_PARAMS = {
  pageSize: 10,
}
